import { useState, useEffect } from 'react'
import * as React from 'react'
import ReactDOM from 'react-dom'
import styled from 'styled-components'
import clsx from 'clsx'
import zIndex from 'styles/tools/z-index'

export const BackdropElement = styled.div`
  position: fixed;
  inset: 0;
  pointer-events: none;
  background-color: rgba(0, 0, 0, 0);
  transition: background-color .2s;
  z-index: ${zIndex.backdrop};

  &.visible {
    pointer-events: auto;
    background-color: rgba(0, 0, 0, .5);
  }
`

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  visible?: boolean
  /**
   * Don't use a portal for this backdrop
   */
  portalless?: boolean
}

function Backdrop(props: Props) {
  const { portalless, visible, className, ...rest } = props
  const [element, setElement] = useState<HTMLDivElement>()

  useEffect(() => {
    const thisElement = document.createElement('div')
    setElement(thisElement)
    document.body.appendChild(thisElement)

    return () => {
      document.body.removeChild(thisElement)
    }
  }, [])

  if (portalless) {
    return <BackdropElement
      {...rest}
      className={clsx(className, { visible })}
    />
  }

  if (!element) {
    return null
  }

  return ReactDOM.createPortal(
    <BackdropElement
      {...rest}
      className={clsx(className, { visible })}
    />,
    element,
  )
}

export default React.memo(Backdrop)
